var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBlock = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_7380",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300049,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_7380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 22.5C10.9167 22.5 9.61672 22.2375 8.40005 21.7125C7.18338 21.1875 6.12505 20.475 5.22505 19.575C4.32505 18.675 3.61255 17.6167 3.08755 16.4C2.56255 15.1833 2.30005 13.8833 2.30005 12.5C2.30005 11.1167 2.56255 9.81667 3.08755 8.6C3.61255 7.38333 4.32505 6.325 5.22505 5.425C6.12505 4.525 7.18338 3.8125 8.40005 3.2875C9.61672 2.7625 10.9167 2.5 12.3 2.5C13.6834 2.5 14.9834 2.7625 16.2 3.2875C17.4167 3.8125 18.475 4.525 19.375 5.425C20.275 6.325 20.9875 7.38333 21.5125 8.6C22.0375 9.81667 22.3 11.1167 22.3 12.5C22.3 13.8833 22.0375 15.1833 21.5125 16.4C20.9875 17.6167 20.275 18.675 19.375 19.575C18.475 20.475 17.4167 21.1875 16.2 21.7125C14.9834 22.2375 13.6834 22.5 12.3 22.5ZM12.3 20.5C13.2 20.5 14.0667 20.3542 14.9 20.0625C15.7334 19.7708 16.5 19.35 17.2 18.8L6.00005 7.6C5.45005 8.3 5.02922 9.06667 4.73755 9.9C4.44588 10.7333 4.30005 11.6 4.30005 12.5C4.30005 14.7333 5.07505 16.625 6.62505 18.175C8.17505 19.725 10.0667 20.5 12.3 20.5ZM18.6 17.4C19.15 16.7 19.5709 15.9333 19.8625 15.1C20.1542 14.2667 20.3 13.4 20.3 12.5C20.3 10.2667 19.525 8.375 17.975 6.825C16.425 5.275 14.5334 4.5 12.3 4.5C11.4 4.5 10.5334 4.64583 9.70005 4.9375C8.86672 5.22917 8.10005 5.65 7.40005 6.2L18.6 17.4Z",
    fill: "#757575"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/block.5b0388c3.svg";
export { ForwardRef as ReactComponent };